import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export function useShowNewlyCreatedPetitions(): boolean {
	const {
		data: {
			featureConfigs: { newlyCreatedPetitionsEnabled },
		},
	} = usePetitionDetailsPageData();

	return newlyCreatedPetitionsEnabled;
}
